import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute, ParamMap, Event } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, NgForm } from '@angular/forms';
import { switchMap } from 'rxjs/operators';
import { LoadJsService } from '../../load-js/load-js.service';
import { ApiPartnerService } from '../../api/api-partner.service';
import swal from 'sweetalert/dist/sweetalert.min.js';

@Component({
  selector: 'app-promo',
  templateUrl: './promo.component.html',
  styleUrls: ['./promo.component.css']
})
export class PromoComponent implements OnInit {
  @ViewChild('closeBtn', { static: false }) closeBtn: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private fb: FormBuilder,
	  private router: Router,
    public LoadJs: LoadJsService,
	  public partnerService: ApiPartnerService
  ) { }

  Promolist: any = [];
  Tenor: any = [];
  Promocategory: any = [];
  
  dataupdate: any = [];
  arraychannel: any = [];
  response: any = {};
  itemdihapus: any = {};
  pcodeold: any = {};

  formPromo = this.fb.group({
    name: [''],
    promocode: [''],
    promocategoryid: [''],
    tenorid: [''],
    startdate: [''],
    enddate: [''],
    description: [''],
  })

  statusx:boolean = false
  table_load = false
  checkx = false
  tenoridx: any

  alert_act=''

  //pagination
  msearch : string;
  searchtype : any;
  promocategory : any;
  
  meta = [];
  self = [];
  paging : any = {};
  page_self = [];
  page_next = [];
  page_prev = [];
  last_index : number;
  first_index : number;
  total_count : number;
  querySearch = false;
  searching = false;
  dataempty = true;
  currentParams = {};
  queryParams = '';
  searchQueryParams = '';
  href='';

  ngOnInit() {
    this.loadStart()
  }
  
  loadStart() {
    
    this.route.queryParams
      //.filter(params => params.order)
      .subscribe(params => {
        console.log(params); // {order: "popular"}

        //this.order = params.order;
        //console.log(this.order); // popular

        if ((params.search != '' || params.searchtype != '' ) && params.search != undefined ){
         this.msearch = params.search; 
         this.searchtype = params.searchtype; 
         this.querySearch = true;
        
         this.currentParams = params;
         this.queryParams = '?'+this.queryStr(params);
         this.loadPromo(this.queryParams);
        
        }else{
          this.querySearch = false;
          this.currentParams = params;

          this.queryParams = '?'+this.queryStr(params);
          console.log(this.queryParams);
          console.log(this.queryStr(params));
          /* pagination */
          //this.loadworkorder(this.currentParams);
          this.loadPromo(this.queryParams);
        }
      });
    this.LoadJs.loadScriptOrderService()
    this.loadTenor()
    this.loadPromocategory()
  }

  refreshPage() {
    
    this.msearch = undefined
    this.searchtype = undefined

    this.ngOnInit();
  }
  clearForm() {
    this.formPromo.reset()
  }

  queryStr(options: any){
    let params = new URLSearchParams();
    for(let key in options){
        params.set(key, options[key]) 
    }
    return params.toString();
  }

  search()
  {
    if ( this.msearch == undefined){
      this.msearch = '';
    }

    this.querySearch = true;
    if ( this.searchtype == undefined ){
      this.searchQueryParams = '?page='+this.page_self['page']+'&search='+this.msearch;
    }else{
      this.searchQueryParams = '?page='+this.page_self['page']+'&search='+this.msearch+'&searchtype='+this.searchtype;
    }
    
    // if ( this.provisioningcode != undefined ){
    //   this.searchQueryParams += '&provisioningcode='+this.provisioningcode;
    // }
    this.loadPromo(this.searchQueryParams);
  }


  private closeModal(): void {
    this.closeBtn.nativeElement.click();
  }
  alertsx(message:any){
    swal({
      title: "Sukses!",
      text: message,
      icon: "success",
    });
    setTimeout(()=>{
      this.closeModal()
      this.ngOnInit()
    }, 1000);
  }
  alertfx(message:any){
    swal({
      title: "Gagal!",
      text: message,
      icon: "error",
    });
    
  }

  onActionClick(act:any, item: any)
  {
    this.alert_act = act;

    if ( act == "create") {
      this.statusx = false
      this.clearForm();
    }
    if ( act == "update") {
      this.statusx = false
      this.onUpdate(item)
    }
  }

  onUpdate(item: any)
  {
    return this.partnerService.Viewpromodetail(item.id).subscribe((output: any) => {
      this.dataupdate = output.data

      this.tenoridx = this.dataupdate.tenorid
      this.formPromo.get('name').setValue(this.dataupdate.name)
      this.formPromo.get('promocode').setValue(this.dataupdate.promocode)
      this.formPromo.get('promocategoryid').setValue(this.dataupdate.promocategoryid)
      this.formPromo.get('tenorid').setValue(this.dataupdate.tenorid)
      this.formPromo.get('startdate').setValue(this.dataupdate.startdate)
      this.formPromo.get('enddate').setValue(this.dataupdate.enddate)
      this.formPromo.get('description').setValue(this.dataupdate.description)

    })
  }

  submitDelete() {
    let item = this.dataupdate
    console.log(item)
    swal({
      title: "Are you sure?",
      text: '"'+item.name+'" akan dihapus',
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willDelete) => {
      if (willDelete) {
        console.log(item)
        this.partnerService.Deletepromo(item.id)
          .subscribe((output: any) => { 
            if (output.status == true) {
              this.alertsx('"'+item.name+'" berhasil dihapus')
            } else {
              this.alertfx('"'+item.name+'" gagal dihapus')
            }
        })
        
      }
    });
    
  }

  submitSave() {
    // console.log(this.formPromo.value)
    this.partnerService.Addpromo(this.formPromo.value).subscribe((output: any) => { 
      // console.log(output)
      if (output.status == true) {
        this.alertsx(output.message)
      } else {
        this.alertfx(output.message)
      }
    });
  }

  submitUpdate() {
    console.log(this.dataupdate, this.formPromo.value)
    this.partnerService.Updatepromo(this.dataupdate.id, this.formPromo.value).subscribe((output: any) => { 
      if (output.status == true) {
        this.alertsx(output.message)
      } else {
        this.alertfx(output.message)
      }
    });
  }

  loadTenor() {
    return this.partnerService.Gettenor().subscribe((output: any) => {
      this.Tenor = output.data;
    })
  }
  loadPromocategory() {
    return this.partnerService.Getpromocategory().subscribe((output: any) => {
      this.Promocategory = output.data;
    })
  }

  loadPromo(params: any) {
    this.table_load = true;
    return this.partnerService.Getpromolist(params).subscribe((output: any) => {
    console.log(output);
      this.Promolist = output.data;

      this.table_load = false;

      this.paging = output.pagex;
      this.page_self = output.pagex.self;
      this.page_next = output.pagex.next;
      this.page_prev = output.pagex.prev;
      this.meta = output.meta;
      this.total_count = this.meta['totalCount'];
      let self = this.page_self['page'];
      if ( self * this.meta['perPage'] < this.meta['totalCount']){
        this.last_index = (self * this.meta['perPage']);
      }else{
        this.last_index = this.meta['totalCount'];
      }
      
      this.first_index = ((self-1)*this.meta['perPage'])+1;
    })
  }

}
